import { useMemo, useState } from "react";
import { Button } from "react-bootstrap";
import { showNotification } from "./notification";
import { t } from "i18next";
import Loader from "./Loader";
import { DeviceGattApi } from "./DeviceGattApi";

function BluetoothConnectButton({ deviceNamePrefix, deviceChanged }) {
    const [state, setState] = useState("disconnected");
    const [device, setDevice] = useState(null);

    const options = useMemo(() => {
        return {
            filters: [
                {
                    // services: getAllServices(),
                    namePrefix: deviceNamePrefix
                }
            ],
            optionalServices: DeviceGattApi.getAllServices()
        }
    }, [deviceNamePrefix]);

    function checkWebBluetoothApi() {
        if (!navigator || !navigator.bluetooth) {
            showNotification(t("bluetooth.notAvailable"), "danger");
            return false;
        }

        return true;
    }

    function connect() {
        if (!checkWebBluetoothApi() || state !== "disconnected" || device !== null) {
            return;
        }

        setState("connecting");

        navigator.bluetooth.requestDevice(options)
            .then(device => {
                setDevice(device);
                device.gatt.connect()
                    .then(() => {
                        setState("connected");
                        deviceChanged(device);

                        device.addEventListener("gattserverdisconnected", () => {
                            setState("disconnected");
                            setDevice(null);
                            deviceChanged(null);
                        });
                    })
                    .catch(error => {
                        setState("disconnected");
                        setDevice(null);
                        deviceChanged(null);
                        showNotification(t("connect.error") + ": " + error.message, "danger");
                    });
            })
            .catch(error => {
                setState("disconnected");
                setDevice(null);
                deviceChanged(null);
                showNotification(t("connect.deviceDiscoveryError") + ": " + error.message, "danger");
            });
    }

    function disconnect() {
        if (!checkWebBluetoothApi() || state !== "connected" || device === null) {
            return;
        }

        const deviceCopy = device;
        setDevice(null);
        deviceChanged(null);
        setState("disconnecting");

        // disconnect after timeout       
        setTimeout(() => {
            deviceCopy.gatt.disconnect();
            setState("disconnected");
        }, 1000);
    }

    function renderButtonText() {
        if (state === "disconnected") {
            return t("connect.connect");
        } else if (state === "connecting") {
            return Loader({ text: t("connect.connecting"), compact: true });
        } else if (state === "connected") {
            return t("connect.disconnect");
        } else if (state === "disconnecting") {
            return Loader({ text: t("connect.disconnecting"), compact: true });
        }

        return "";
    }

    return (
        <Button variant="primary" disabled={state === "connecting"} onClick={() => {
            if (state === "disconnected") {
                connect();
            } else {
                disconnect();
            }
        }}>
            {renderButtonText()}
        </Button>
    );
}

export default BluetoothConnectButton;
